import styled from "@emotion/styled";

export const StyledLoadingSpinner = styled.div`
  .mds-icon-wrapper .mds-icon {
    animation-duration: 0.5s !important;
  }
`;
